class Subject {
    constructor() {
        this.observers = [];
    }

    subscribe(observer) {
        this.observers.push(observer);
    }

    unsubscribe(observer) {
        const index = this.observers.indexOf(observer);
        if (index > -1) {
            this.observers.splice(index, 1);
        }
    }

    notify(data) {
        this.observers.forEach(observer => observer.update(data));
    }
}

class Observer {
    fun;
    constructor(fun) {
        this.fun = fun; // 声明一个属性并赋值
    }

    update(data) {
        this.fun(data);
        console.log("Observer: Received data: ", data);
    }
}

const subjectInstance  = new Subject();


export  {subjectInstance as SubjectInstance ,Observer}

// subject.subscribe(observer1);
// subject.subscribe(observer2);
//
// subject.notify('Hello Observers!');
//
// subject.unsubscribe(observer1);
//
// subject.notify('Second notification');
